/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MessagesInputs */

const en_messages = /** @type {(inputs: MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages`)
};

const es_messages = /** @type {(inputs: MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensajes`)
};

const fr_messages = /** @type {(inputs: MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages`)
};

const de_messages = /** @type {(inputs: MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachrichten`)
};

const ja_messages = /** @type {(inputs: MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メッセージ`)
};

const zh_messages = /** @type {(inputs: MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消息`)
};

const ar_messages = /** @type {(inputs: MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الرسائل`)
};

const id_messages = /** @type {(inputs: MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan`)
};

const it_messages = /** @type {(inputs: MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messaggi`)
};

const ru_messages = /** @type {(inputs: MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сообщения`)
};

const pt_messages = /** @type {(inputs: MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagens`)
};

const ko_messages = /** @type {(inputs: MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메시지`)
};

/**
* | output |
* | --- |
* | "Messages" |
*
* @param {MessagesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const messages = /** @type {((inputs?: MessagesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MessagesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages(inputs)
	if (locale === "es") return es_messages(inputs)
	if (locale === "fr") return fr_messages(inputs)
	if (locale === "de") return de_messages(inputs)
	if (locale === "ja") return ja_messages(inputs)
	if (locale === "zh") return zh_messages(inputs)
	if (locale === "ar") return ar_messages(inputs)
	if (locale === "id") return id_messages(inputs)
	if (locale === "it") return it_messages(inputs)
	if (locale === "ru") return ru_messages(inputs)
	if (locale === "pt") return pt_messages(inputs)
	return ko_messages(inputs)
});